import moment from 'moment-jalaali'

function addCommaToPriceUnsigned(price: number | string) {
  if (price === 0) {
    return price
  }
  if (!price) {
    return ''
  }
  const splittedPrice = price.toString().split('.')
  if (splittedPrice[0].toString().length > 3) {
    const formattedPrice = splittedPrice[0]
      .toString()
      .split('')
      .reverse()
      .join('')
      .replace(/.{3}/g, '$&,')
      .split('')
      .reverse()
      .join('')
    if (formattedPrice.toString().charAt(0) === ',') {
      return `${formattedPrice.substr(1)}${
        splittedPrice[1] ? `.${splittedPrice[1]}` : ''
      }`
    }
    return `${formattedPrice}${splittedPrice[1] ? `.${splittedPrice[1]}` : ''}`
  }
  return price
}

export function addCommaToPrice(price: string | number) {
  if (price && price.toString().length > 0 && price.toString()[0] === '-') {
    return `-${addCommaToPriceUnsigned(price.toString().substring(1))}`
  }
  return addCommaToPriceUnsigned(price)
}

// Iranian numbers in their local form: "+98(11)52188813" -> "011-52188813",
// "+982129112000" -> "02129112000". Production stores the area code in parentheses.
export function toLocalPhone(phone?: string | null) {
  if (!phone) return ''
  const withAreaCode = phone.match(/^\+98\s*\((\d+)\)\s*(.+)$/)
  if (withAreaCode) return `0${withAreaCode[1]}-${withAreaCode[2]}`
  return phone.replace(/^\+98\s*/, '0')
}

// Jalali date with slashes, matching check-in/check-out. Parsed with an explicit format so
// a browser west of UTC cannot shift a plain date to the previous day.
export function formatJalaaliDate(date: string) {
  return moment(date, 'YYYY-MM-DD').format('jYYYY/jMM/jDD')
}

// This renderer (react-pdf 3.1) reverses each run of digits inside RTL text, so numbers are
// pre-reversed before rendering. That only works on Western digits: Persian and Arabic
// digits are normalised first (the FaNum font draws Western digits as Persian glyphs).
export function toLatinDigits(input: string) {
  return input
    .replace(/[\u06F0-\u06F9]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
    .replace(/[\u0660-\u0669]/g, (d) => String(d.charCodeAt(0) - 0x0660))
}

export function reverseNumbers(input: string) {
  return toLatinDigits(input).replace(
    /\d{1,2}:\d{1,2}(?::\d{1,2})?|\d+/g,
    (match) => {
      if (match.includes(':')) {
        // Reverse the digits but keep each colon in place.
        const reversedDigits = match.replace(/\D/g, '').split('').reverse()
        let index = 0
        return match.replace(/\d/g, () => reversedDigits[index++] || '')
      }
      return match.split('').reverse().join('')
    }
  )
}

// This renderer draws "(" and ")" mirrored inside RTL text, so they are swapped before
// rendering; the same swap the room-type name already uses.
export function mirrorParens(input: string) {
  return input.replace(/\(|\)/g, (paren) => (paren === ')' ? '(' : ')'))
}
